import type { AxiosInstance } from 'axios'
import { inject, type Ref } from 'vue'

export function useCoreApi() {
  const coreRestApiAxios = inject<Ref<AxiosInstance | undefined>>('coreRestApiAxios')

  if (!coreRestApiAxios?.value) {
    return {}
  }

  return { coreRestApiAxios }
}
